import script from "./GetStartBoarding.vue?vue&type=script&setup=true&lang=js"
export * from "./GetStartBoarding.vue?vue&type=script&setup=true&lang=js"

import "./GetStartBoarding.vue?vue&type=style&index=0&id=015dda33&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-015dda33"]])

export default __exports__